import {
  AlignCenterIcon,
  AlignLeftIcon,
  AlignRightIcon,
  ArrowBackUpIcon,
  ArrowForwardUpIcon,
  BoldIcon,
  BulletListIcon,
  ClearFormattingIcon,
  H1Icon,
  H2Icon,
  H3Icon,
  ItalicIcon,
  NumberedListIcon,
  StrikethroughIcon,
  SubscriptIcon,
  SuperscriptIcon,
  UnderlineIcon,
} from '../icons';

import RichTextEditorControl from './rich-text-editor-control';

export function BoldControl() {
  return (
    <RichTextEditorControl
      icon={BoldIcon}
      label='Bold Control'
      operation={{ name: 'toggleBold' }}
      active={{ name: 'bold' }}
    />
  );
}

export function ItalicControl() {
  return (
    <RichTextEditorControl
      icon={ItalicIcon}
      label='Italic Control'
      operation={{ name: 'toggleItalic' }}
      active={{ name: 'italic' }}
    />
  );
}

export function UnderlineControl() {
  return (
    <RichTextEditorControl
      icon={UnderlineIcon}
      label='Underline Control'
      operation={{ name: 'toggleUnderline' }}
      active={{ name: 'underline' }}
    />
  );
}

export function StrikethroughControl() {
  return (
    <RichTextEditorControl
      icon={StrikethroughIcon}
      label='Strikethrough Control'
      operation={{ name: 'toggleStrike' }}
      active={{ name: 'strike' }}
    />
  );
}

export function ClearFormattingControl() {
  return (
    <RichTextEditorControl
      icon={ClearFormattingIcon}
      label='Clear Formatting Control'
      operation={{ name: 'unsetAllMarks' }}
    />
  );
}

export function SuperscriptControl() {
  return (
    <RichTextEditorControl
      icon={SuperscriptIcon}
      label='Superscript Control'
      operation={{ name: 'toggleSuperscript' }}
      active={{ name: 'superscript' }}
    />
  );
}

export function SubscriptControl() {
  return (
    <RichTextEditorControl
      icon={SubscriptIcon}
      label='Subscript Control'
      operation={{ name: 'toggleSubscript' }}
      active={{ name: 'subscript' }}
    />
  );
}

export function UndoControl() {
  return (
    <RichTextEditorControl
      icon={ArrowBackUpIcon}
      label='Undo Control'
      operation={{ name: 'undo' }}
      disabled={(editor) => !editor?.can().undo()}
    />
  );
}

export function RedoControl() {
  return (
    <RichTextEditorControl
      icon={ArrowForwardUpIcon}
      label='Redo Control'
      operation={{ name: 'redo' }}
      disabled={(editor) => !editor?.can().redo()}
    />
  );
}

export function BulletListControl() {
  return (
    <RichTextEditorControl
      icon={BulletListIcon}
      label='Bullet List Control'
      operation={{ name: 'toggleBulletList' }}
    />
  );
}

export function NumberListControl() {
  return (
    <RichTextEditorControl
      icon={NumberedListIcon}
      label='Numbered List Control'
      operation={{ name: 'toggleOrderedList' }}
    />
  );
}

export function AlignLeftControl() {
  return (
    <RichTextEditorControl
      icon={AlignLeftIcon}
      label='Align Left Control'
      operation={{ name: 'setTextAlign', attributes: 'left' }}
    />
  );
}

export function AlignCenterControl() {
  return (
    <RichTextEditorControl
      icon={AlignCenterIcon}
      label='Align Center Control'
      operation={{ name: 'setTextAlign', attributes: 'center' }}
    />
  );
}

export function AlignRightControl() {
  return (
    <RichTextEditorControl
      icon={AlignRightIcon}
      label='Align Right Control'
      operation={{ name: 'setTextAlign', attributes: 'right' }}
    />
  );
}

export function H1Control() {
  return (
    <RichTextEditorControl
      icon={H1Icon}
      label='H1 Control'
      active={{ name: 'heading', attributes: { level: 1 } }}
      operation={{ name: 'toggleHeading', attributes: { level: 1 } }}
    />
  );
}

export function H2Control() {
  return (
    <RichTextEditorControl
      icon={H2Icon}
      label='H2 Control'
      active={{ name: 'heading', attributes: { level: 2 } }}
      operation={{ name: 'toggleHeading', attributes: { level: 2 } }}
    />
  );
}

export function H3Control() {
  return (
    <RichTextEditorControl
      icon={H3Icon}
      label='H3 Control'
      active={{ name: 'heading', attributes: { level: 3 } }}
      operation={{ name: 'toggleHeading', attributes: { level: 3 } }}
    />
  );
}
